"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tradeReportsSelectorFactory = exports.sellOpenOrdersSelector = exports.openOrdersSelectorFactory = exports.openOrdersSelector = exports.openOrdersCountSelector = exports.inactiveOrdersSelectorFactory = exports.filledOrdersSelectorFactory = exports.buyOpenOrdersSelector = exports.allOpenOrdersSelector = void 0;
var _reselect = require("reselect");
var _numberFormatter = require("../../helpers/numberFormatter");
var _instrumentPositionSelectors = require("./instrumentPositionSelectors");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var openOrdersCurrencySelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.orderHistory.openOrders;
}, function (state) {
  return state.apexCore.instrument.instruments;
}, function (state) {
  return state.apexCore.orderHistory.tradeReports;
}], convertOrderNumbersToCurrency);
var trailingOrdersSelectorFactory = function trailingOrdersSelectorFactory(ordersSelector) {
  return (0, _reselect.createSelector)(ordersSelector, function (orders) {
    return orders.map(function (order) {
      if (order.OrderType === 'TrailingStopLimit' || order.OrderType === 'TrailingStopMarket') {
        return _objectSpread(_objectSpread({}, order), {}, {
          trailingPrice: 'TRL'
        });
      }
      return order;
    });
  });
};
var openOrdersFilter = function openOrdersFilter(orders) {
  return orders.filter(function (order) {
    return order.OrderState !== 'FullyExecuted' && order.OrderState === 'Working';
  }).sort(function (a, b) {
    return b.ReceiveTime - a.ReceiveTime;
  });
};
var openOrdersSelector = exports.openOrdersSelector = (0, _reselect.createSelector)(openOrdersCurrencySelector, function (state) {
  return state.user.selectedAccountId;
}, _instrumentPositionSelectors.selectedInstrumentIdSelector, function (orders, selectedAccountId, selectedInstrumentId) {
  return orders.filter(function (order) {
    return order.OrderState !== 'FullyExecuted' && order.OrderState === 'Working' && (!selectedAccountId || order.Account === selectedAccountId) && (!selectedInstrumentId || order.Instrument === selectedInstrumentId);
  }).sort(function (a, b) {
    return b.ReceiveTime - a.ReceiveTime;
  });
});
var openOrdersCountSelector = exports.openOrdersCountSelector = (0, _reselect.createSelector)(openOrdersSelector, function (orders) {
  return orders.length || 0;
});

// Selector for all open orders without instrument filtering (for "Show All Open Orders" feature)
var allOpenOrdersSelector = exports.allOpenOrdersSelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.orderHistory.openOrders;
}, function (state) {
  return state.apexCore.instrument.instruments;
}, function (state) {
  return state.user.selectedAccountId;
}, function (state) {
  return state.apexCore.orderHistory.tradeReports;
}], function (orders, instruments, selectedAccountId, tradeReports) {
  // Combine orders and tradeReports
  var allOrders = [].concat(_toConsumableArray(orders), _toConsumableArray(tradeReports));
  return allOrders.filter(function (order) {
    return !!order;
  }).filter(function (order) {
    return order.OrderState !== 'FullyExecuted' && order.OrderState === 'Working' && (!selectedAccountId || order.Account === selectedAccountId);
  }).sort(function (a, b) {
    return b.ReceiveTime - a.ReceiveTime;
  }).map(function (order) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.Instrument;
    });
    if (!instrument) {
      return order;
    }
    var Product1Symbol = instrument.Product1Symbol,
      Product2Symbol = instrument.Product2Symbol;
    var quantity = (0, _numberFormatter.currency)(order.Quantity, Product1Symbol);
    var origQuantity = (0, _numberFormatter.currency)(order.OrigQuantity, Product1Symbol);
    var price = (0, _numberFormatter.currency)(order.Price, Product2Symbol);
    var processedOrder = _objectSpread(_objectSpread({}, order), {}, {
      quantity: quantity,
      OrigQuantity: origQuantity,
      Price: price,
      instrument: instrument
    });
    if (order.OrderType === 'TrailingStopLimit' || order.OrderType === 'TrailingStopMarket') {
      return _objectSpread(_objectSpread({}, processedOrder), {}, {
        trailingPrice: 'TRL'
      });
    }
    return processedOrder;
  });
});
var openOrdersSelectorFactory = exports.openOrdersSelectorFactory = function openOrdersSelectorFactory(nextPageOrders) {
  return (0, _reselect.createSelector)([trailingOrdersSelectorFactory(openOrdersSelector), function (state) {
    return state.apexCore.instrument.instruments;
  }], function (orders, instruments) {
    // Processing next page orders for pagination.
    if (nextPageOrders) orders = openOrdersFilter(nextPageOrders);
    var filteredOrders = mapInstrumentToOrders(orders, instruments);
    return filteredOrders;
  });
};
var buyOpenOrdersSelector = exports.buyOpenOrdersSelector = (0, _reselect.createSelector)(openOrdersSelectorFactory(), function (orders) {
  return orders.filter(function (order) {
    return order.Side === 'Buy' && order.OrderType !== 'BlockTrade';
  });
});
var sellOpenOrdersSelector = exports.sellOpenOrdersSelector = (0, _reselect.createSelector)(openOrdersSelectorFactory(), function (orders) {
  return orders.filter(function (order) {
    return order.Side === 'Sell' && order.OrderType !== 'BlockTrade';
  });
});
var accountTradesCurrencySelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.orderHistory.accountTrades;
}, function (state) {
  return state.apexCore.instrument.instruments;
}, function (state) {
  return state.apexCore.product.products;
}], function (trades, instruments, products) {
  return trades.map(function (trade) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === trade.InstrumentId;
    });
    if (!instrument) return {};
    var Product1Symbol = instrument.Product1Symbol,
      Product2Symbol = instrument.Product2Symbol;
    var quantity = (0, _numberFormatter.currency)(trade.Quantity, Product1Symbol);
    var price = (0, _numberFormatter.currency)(trade.Price, Product2Symbol);
    var symbol = trade.Side === 'Buy' ? Product1Symbol : Product2Symbol;
    var value = (0, _numberFormatter.currency)(trade.Value, symbol);
    var feeProduct = products.find(function (p) {
      return p.ProductId === trade.FeeProductId;
    });
    var fee = (0, _numberFormatter.currency)(trade.Fee, feeProduct ? feeProduct.Product : symbol);
    return _objectSpread(_objectSpread({}, trade), {}, {
      Quantity: quantity,
      Price: price,
      Value: value,
      Fee: fee
    });
  });
});

/**
 * @TODO - is there a better way to remove block trades?....
 */

var filledOrdersSelectorFilter = function filledOrdersSelectorFilter(trades, selectedInstrumentId) {
  return trades.filter(function (trade) {
    return !trade.IsBlockTrade && (!selectedInstrumentId || trade.InstrumentId === selectedInstrumentId);
  }).sort(function (a, b) {
    if (a.TradeTime < b.TradeTime) return 1;
    if (a.TradeTime > b.TradeTime) return -1;
    return 0;
  });
};
var filledOrdersSelector = (0, _reselect.createSelector)([accountTradesCurrencySelector, _instrumentPositionSelectors.selectedInstrumentIdSelector], function (trades, selectedInstrumentId) {
  return filledOrdersSelectorFilter(trades, selectedInstrumentId);
});
var filledOrdersSelectorFactory = exports.filledOrdersSelectorFactory = function filledOrdersSelectorFactory(nextPageOrders) {
  return (0, _reselect.createSelector)([trailingOrdersSelectorFactory(filledOrdersSelector), function (state) {
    return state.apexCore.instrument.instruments;
  }], function (orders, instruments) {
    // Processing next page orders for pagination.
    if (nextPageOrders) orders = filledOrdersSelectorFilter(nextPageOrders);
    var filteredOrders = mapInstrumentToOrders(orders, instruments);
    return filteredOrders;
  });
};
var inactiveOrdersCurrencySelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.orderHistory.inactiveOrders;
}, function (state) {
  return state.apexCore.instrument.instruments;
}], convertOrderNumbersToCurrency);
var inactiveOrdersFilter = function inactiveOrdersFilter(orders, selectedInstrumentId) {
  return orders.filter(function (order) {
    return order.OrderState !== 'FullyExecuted' && order.OrderState !== 'Working' && (!selectedInstrumentId || order.Instrument === selectedInstrumentId);
  }).sort(function (a, b) {
    return b.ReceiveTime - a.ReceiveTime;
  });
};
var inactiveOrdersSelector = (0, _reselect.createSelector)([inactiveOrdersCurrencySelector, _instrumentPositionSelectors.selectedInstrumentIdSelector], function (orders, selectedInstrumentId) {
  return inactiveOrdersFilter(orders, selectedInstrumentId);
});
var inactiveOrdersSelectorFactory = exports.inactiveOrdersSelectorFactory = function inactiveOrdersSelectorFactory() {
  return (0, _reselect.createSelector)([trailingOrdersSelectorFactory(inactiveOrdersSelector), function (state) {
    return state.apexCore.instrument.instruments;
  }], function (orders, instruments) {
    var filteredOrders = mapInstrumentToOrders(orders, instruments);
    return filteredOrders;
  });
};
function isOrder(obj) {
  if (!obj || _typeof(obj) !== 'object') {
    return false;
  }
  var hasInstrument = 'Instrument' in obj;
  var hasOrderState = 'OrderState' in obj;
  var hasTiming = 'ReceiveTime' in obj || 'TradeTime' in obj || 'ReceiveTimeTicks' in obj;
  return hasInstrument && hasOrderState && hasTiming;
}
function isTradeReport(obj) {
  if (!obj || _typeof(obj) !== 'object') {
    return false;
  }
  var hasInstrumentId = 'InstrumentId' in obj;
  var hasTiming = 'TradeTimeMS' in obj || 'ReceiveTimeTicks' in obj;
  var isNotOrder = !('OrderState' in obj);
  return hasInstrumentId && hasTiming && isNotOrder;
}
function convertOrderNumbersToCurrency(orders, instruments) {
  var tradeReports = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var ordersArray = Array.isArray(orders) ? orders : [orders];
  var tradeReportsArray = Array.isArray(tradeReports) ? tradeReports : [tradeReports];
  var allOrders = [].concat(_toConsumableArray(ordersArray), _toConsumableArray(tradeReportsArray));
  return allOrders.filter(function (order) {
    return isOrder(order) || isTradeReport(order);
  }).map(function (order) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.Instrument;
    });
    if (!instrument) {
      return order;
    }
    var Product1Symbol = instrument.Product1Symbol,
      Product2Symbol = instrument.Product2Symbol;
    var quantity = (0, _numberFormatter.currency)(order.Quantity, Product1Symbol);
    var origQuantity = (0, _numberFormatter.currency)(order.OrigQuantity, Product1Symbol);
    var price = (0, _numberFormatter.currency)(order.Price, Product2Symbol);
    return _objectSpread(_objectSpread({}, order), {}, {
      quantity: quantity,
      OrigQuantity: origQuantity,
      Price: price
    });
  });
}
var tradeReportsCurrencySelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.orderHistory.tradeReports;
}, function (state) {
  return state.apexCore.instrument.instruments;
}], function (tradeReports, instruments) {
  var trades = tradeReports.filter(function (order) {
    return order.OrderState !== 'Working';
  });
  var modifiedTradeReports = trades.map(function (order) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.InstrumentId || order.Instrument;
    });
    var Product1Symbol = instrument.Product1Symbol,
      Product2Symbol = instrument.Product2Symbol;
    var quantity = (0, _numberFormatter.currency)(order.Quantity, Product1Symbol);
    var price = (0, _numberFormatter.currency)(order.Price, Product2Symbol);
    var symbol = order.Side === 'Buy' ? Product1Symbol : Product2Symbol;
    var fee = (0, _numberFormatter.currency)(order.Fee, symbol);
    return _objectSpread(_objectSpread({}, order), {}, {
      Quantity: quantity,
      Price: price,
      Fee: fee
    });
  });
  return modifiedTradeReports;
});
var tradeReportsSelector = (0, _reselect.createSelector)([tradeReportsCurrencySelector, accountTradesCurrencySelector], function (tradeReports, accountTrades) {
  var blockTrades = accountTrades.filter(function (trade) {
    return trade.IsBlockTrade;
  });
  return tradeReports.concat(blockTrades).map(function (order) {
    return _objectSpread(_objectSpread({}, order), {}, {
      SortingTime: order.ReceiveTimeTicks ? order.ReceiveTimeTicks : order.TradeTime
    });
  }).sort(function (a, b) {
    if (a.SortingTime < b.SortingTime) return 1;
    if (a.SortingTime > b.SortingTime) return -1;
    return 0;
  });
});
var tradeReportsSelectorFactory = exports.tradeReportsSelectorFactory = function tradeReportsSelectorFactory() {
  return (0, _reselect.createSelector)([trailingOrdersSelectorFactory(tradeReportsSelector), function (state) {
    return state.apexCore.instrument.instruments;
  }, function (state) {
    return state.apexCore.orderHistory.accountTrades;
  }], function (orders, instruments) {
    var filteredOrders = mapInstrumentToOrders(orders, instruments);
    return filteredOrders;
  });
};
var mapInstrumentToOrders = function mapInstrumentToOrders(orders, instruments) {
  return orders.map(function (order) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.Instrument || item.InstrumentId === order.InstrumentId;
    });
    return _objectSpread(_objectSpread({}, order), {}, {
      instrument: instrument
    });
  });
};